export const useVideocastPage = async () => {
  const route = useRoute()
  const { locale } = useI18n()

  const { data } = await useAsyncData(
    `article-${route.path}-${locale.value}`,
    async () => {
      try {
        const [postRes, postsRes] = await Promise.all([
          $fetch('/api/v1/contentful/videocast', {
            query: {
              locale: locale.value,
              path: route.path,
            },
          }),
          $fetch('/api/v1/contentful/videocasts', {
            query: {
              locale: locale.value,
            },
          }),
        ])

        const videocast = postRes?.videocast ?? null
        let videocasts = postsRes?.videocasts ?? []

        videocasts = videocasts
          .filter(el => el.title !== videocast?.title)
          .sort(
            (a, b) =>
              new Date(b.date).getTime() - new Date(a.date).getTime(),
          )

        return {
          videocast,
          videocasts,
        }
      } catch (e) {
        console.error(e)
        return {
          videocast: null,
          videocasts: [],
        }
      }
    },
  )

  const videocast = computed(() => data.value?.videocast)
  const videocasts = computed(() => data.value?.videocasts ?? [])

  return {
    videocast,
    videocasts,
  }
}
